export const PROMO_FETCH_START = 'promo/FETCH_START'
export const PROMO_FETCH_SUCCESS = 'promo/FETCH_SUCCESS'
export const PROMO_FETCH_ERROR = 'promo/FETCH_ERROR'
export const SET_PROMO_CODE = 'promo/SET_PROMO_CODE'
export const CLEAR_VALIDATION = 'promo/CLEAR_VALIDATION'
export const RESET_PROMO_STATE = 'promo/RESET_PROMO_STATE'
